import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import "./App.css";

import { authenticationService } from "./services";

import { SignIn } from "./components/SignIn";
import { AppHeader } from "./components/AppHeader";
import { Stripe } from "./components/Stripe";
import MainPage from "./components/MainPage";
import { SFDCCallback } from "./components/SFDCCallback";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"© " + new Date().getFullYear() + "  "}
            <Link color="inherit" href="https://readymode.com/">
                readymode.com
            </Link>
            <br />
            Readymode Pay Portal
            <br />
            Allows clients to access their account, view payments, and make
            payments — all in one place.
        </Typography>
    );
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userProfile: {},
        };
        this.handelLogout = this.handelLogout.bind(this);
    }

    componentDidMount() {}

    handelLogout() {
        authenticationService.logout();
    }

    render() {
        return (
            <div className="App">
                <Router>
                    <Switch>
                        <Route path="/signin">
                            <AppHeader />
                            <SignIn />
                        </Route>
                        <Route path="/customer-portal">
                            <AppHeader />
                            <Stripe />
                        </Route>
                        <Route path="/portal">
                            <MainPage />
                        </Route>
                        <Route path="/sfdc-callback">
                            <SFDCCallback />
                        </Route>
                        <Route>
                            <MainPage />
                        </Route>
                    </Switch>
                </Router>
                <Box mt={8}>
                    <Copyright />
                </Box>
            </div>
        );
    }
}

export default App;
